module.exports = __webpack_public_path__ + "media/images/les maldives-faf42117cae51581d9430a7ce21f045f.svg";